export const formHeadingStyles = { textAlign:'center',my: 2, fontSize: "18px", fontWeight: 500 };

export const loginBtnStyles = {
  width: "100%",
  padding: "6px 6px",
  borderRadius: "30px",
  marginTop: "1rem",
  fontSize: "14px",
  fontWeight: "500",
};

export const inputPadding={
  padding: "10px 5px"
}
